import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  process.env.TWENTY_API_URL,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  getDomains() {
    return conduit.get('core/domains', [], []);
  },

  getGiftVoucherTemplates(domain) {
    return conduit.get(`cms/gift-vouchers/domain/${domain.id}/templates`);
  },

  addGiftVoucherTemplate(domain, template) {
    return conduit.post(
      `cms/gift-vouchers/domain/${domain.id}/templates/add`,
      template,
    );
  },

  updateGiftVoucherTemplate(template) {
    return conduit.put(
      `cms/gift-vouchers/domain/${template.domainId}/templates/${template.id}/update`,
      template,
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/gift-voucher-template-service.js